<script setup lang="ts">
import { useStore } from '@/core/composables/useStore';
import { onMounted } from 'vue';

const { dispatch } = useStore();

onMounted(() => {
   dispatch('colorTheme/getColorThemes');
});
</script>
<template>
   <RouterView />
</template>
